import { IQuestion } from 'app/interfaces/IQuestion'
import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'
import { IRow } from 'app/interfaces/IRow'

type QuestionWithMatrixMeta = IQuestion & {
  randomizeRows?: boolean
  rows?: Record<string, IRow>
  rowsOrder?: string[]
}

/**
 * QuestionPropertyValidator (used by MatrixPropertyValidator) rejects undefined for
 * base IQuestion fields. MatrixPropertyValidator also assigns randomizeRows from the
 * raw question — Firebase / AI payloads may omit booleans that formatQuestion sets
 * in the builder.
 */
export function normalizeQuestionValidatorFields(question: IQuestion): void {
  const q = question as QuestionWithMatrixMeta
  q.shouldSaveInExtProfile = q.shouldSaveInExtProfile ?? false
  q.isOptional = q.isOptional ?? false
  q.positionLocked = q.positionLocked ?? false
  q.limitAnswersAmount = q.limitAnswersAmount ?? false
  q.randomizeStatements = q.randomizeStatements ?? false
  q.useUniqueMentionLabel = q.useUniqueMentionLabel ?? false
  q.maxAnswers = q.maxAnswers ?? {}
  q.minAnswers = q.minAnswers ?? {}
  q.randomizeRows = q.randomizeRows ?? false
  normalizeMatrixRowsOpenCols(q)
}

function normalizeMatrixRowsOpenCols(question: QuestionWithMatrixMeta): void {
  if (!question.rowsOrder?.length || !question.rows || !question.statementsOrder?.length) {
    return
  }

  const openColsMustBeTrue = [
    ViewerTypeEnum.OPEN,
    ViewerTypeEnum.PROPS,
    ViewerTypeEnum.PHONE,
    ViewerTypeEnum.ADDRESS,
    ViewerTypeEnum.NAME,
    ViewerTypeEnum.EMAIL,
  ].includes(question.viewerType as ViewerTypeEnum)

  question.rowsOrder.forEach(rowKey => {
    const row = question.rows?.[rowKey]
    if (!row) {
      return
    }

    const normalizedOpenCols = question.statementsOrder.reduce<Record<string, boolean>>((acc, statementKey) => {
      const currentValue = row.openCols?.[statementKey]
      if (typeof currentValue === 'boolean') {
        acc[statementKey] = currentValue
      } else {
        acc[statementKey] = openColsMustBeTrue
      }
      return acc
    }, {})

    row.openCols = normalizedOpenCols
  })
}
